class DataTransformations {
  static getSiderHeight() {
    return window.innerHeight - 50;
  }
  static getTableHeight() {
    return window.innerHeight - 250;
  }

  static getTableWidth() {
    return window.innerWidth - 445;
  }

  //toggle item from  deselected array of items
  static toggleDeselectedItem(currentDeselectedItems, toggleItemValue) {
    const idx = currentDeselectedItems.indexOf(toggleItemValue);
    if (idx >= 0)
      //if item already in array of deselectedItem
      currentDeselectedItems.splice(idx, 1); //remove item
    else currentDeselectedItems.push(toggleItemValue); //add item to array
    return currentDeselectedItems;
  }

  //check if item is checked if it is not part of deselecteditems array.
  static isChecked(deselectedItems, item) {
    if (deselectedItems) {
      for (let i = 0; i < deselectedItems.length; i++)
        //eslint-disable-next-line
        if (deselectedItems[i] == item) return true; //allow for number to string comparison.
    }
    return false;
  }

  //get checked items
  static getCheckedItems(processedItems) {
    if (processedItems) return processedItems.filter(i => i.isChecked);
    return processedItems;
  }

  //get columns datetime data from report data for table
  static getTableReportHeaderData(data) {
    let headerData = null;
    if (data) {
      //get data for header and number of columns from  first object
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].data && Object.keys(data[i].data).length > 0) {
          headerData = Object.keys(data[i].data);
          break;
        }
      }
    }
    return headerData;
  }
}

export default DataTransformations;



// WEBPACK FOOTER //
// ./src/utils/data_transformations/dataTransformations.js